import { render, staticRenderFns } from "./ProjectCardComponent.vue?vue&type=template&id=70847e52&scoped=true&"
import script from "./ProjectCardComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardComponent.vue?vue&type=style&index=0&id=70847e52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70847e52",
  null
  
)

export default component.exports